// extracted by mini-css-extract-plugin
export default {"titulo":"Titulos_titulo__Cfm27","ver":"Titulos_ver__TR2Z0"};